import z from 'zod'

export const OutcomeTypeSchema = z.enum([
  'true-positive',
  'likely-true-positive',
  'inconclusive',
  'potentially-exploitable',
  'no-fix-necessary',
  'no-fix-necessary-false-positive',
  'no-fix-necessary-wont-fix',
  'no-fix-necessary-not-exploitable',
  'error',
  'blocked',
  'excluded',
  'exploitable',
])
export type OutcomeType = z.infer<typeof OutcomeTypeSchema>

export const OutcomeReferenceTabSchema = z.enum(['triage', 'fix', 'sca'])
export type OutcomeReferenceTab = z.infer<typeof OutcomeReferenceTabSchema>
